import { useQuery } from '@tanstack/react-query';
import { fetchBadgeCounts } from '../api/badges';

export const BADGE_COUNTS_QUERY_KEY = ['badge-counts'];

const SEEN_KEY = 'rejected-requests-seen-at';

export const getRejectedSeenAt = () => {
  try {
    return localStorage.getItem(SEEN_KEY);
  } catch {
    return null;
  }
};

export const markRejectedSeen = () => {
  try {
    localStorage.setItem(SEEN_KEY, new Date().toISOString());
  } catch {
    /* storage unavailable — badge just stays until next load */
  }
};

/**
 * All the sidebar badge counts from a single polled request (GET /badge-counts) — the per-badge
 * hooks (useStepApprovalCount etc.) just read their slice of this. The server only counts what the
 * signed-in user may see, so a count they have no access to comes back 0. Polled rather than
 * pushed — there's no websocket/SSE layer — and react-query pauses polling in background tabs.
 */
export function useBadgeData() {
  return useQuery({
    queryKey: BADGE_COUNTS_QUERY_KEY,
    queryFn: () => fetchBadgeCounts(getRejectedSeenAt()),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

/** Refresh the badges now — call after an action that changes a queue (approve, reject, assign…). */
export const invalidateBadgeCounts = (queryClient) => queryClient.invalidateQueries({ queryKey: BADGE_COUNTS_QUERY_KEY });
